import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default function AspectosGenerales() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>I. ASPECTOS GENERALES</h4>
          <br></br>
          <p>
            <strong>Parking International S.A.S.</strong> (en adelante “Parking”) es una sociedad constituida bajo las leyes colombianas, identificada con NIT 860.058.760-1 y con domicilio en Bogotá D.C. Su objeto social es operar parqueaderos para todo tipo de vehículos, incluyendo la instalación, mantenimiento y operación de zonas de parqueo tanto en vía como fuera de vía.
          </p>
          
          <br></br>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>II. OBJETIVO</h4>
                  <br></br>
          <p>
            Los presentes Términos y Condiciones Generales (en adelante los “T&C”) regulan el acceso y uso de los Servicios ofrecidos por Parking al Usuario (en adelante el “Usuario”) o Cliente Corporativo (en adelante el “Cliente Corporativo”) en la aplicación móvil llamada Go Parking (en adelante la “App”), en la página web (en adelante la “Página web”) y en la Landing Corp (en adelante la “Landing Corp”), (conjuntamente las “Plataformas”) de Parking.
          </p>

          <p>El contenido de las Plataformas está destinado y/o relacionado con la venta de los Servicios ofrecidos por Parking. Lo aquí dispuesto será de acatamiento obligatorio para el Usuario y/o Cliente Corporativo. Se entenderá que todo Usuario y/o Cliente Corporativo, al decidir contratar con Parking ha leído y aceptado las condiciones y limitaciones establecidas en los presentes T&C. La decisión de contratar los Servicios implica la decisión del Usuario y/o el Cliente Corporativo de obligarse por estas condiciones y por las decisiones debidamente informadas por Parking.</p>
          
          <br></br>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>III. TERRITORIO</h4>
          <br></br>
          <p>Los presentes T&C aplican en el territorio colombiano.</p>
        </Col>
      </Row>
    </Container>
  );
}